import { useCallback } from 'react'

export const useScrollOnMount = <El extends HTMLElement>() => {
  return useCallback((node: El) => {
    if (node) {
      node.scrollIntoView()
    }
  }, [])
}
